"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZECSubPackage = void 0;
const zec_1 = require("../logic/zec");
class ZECSubPackage {
    constructor(signer) {
        this.etherSigner = signer;
    }
    updateTotalZecBLSPublicKeyLimit(newLimit) {
        return (0, zec_1._updateTotalZecBLSPublicKeyLimit)(this.etherSigner, newLimit);
    }
    updateDAOAddress(liquidStakingManagerAddress, previousDAOAddress, newDAOAddress) {
        return (0, zec_1._updateDAOAddress)(this.etherSigner, liquidStakingManagerAddress, previousDAOAddress, newDAOAddress);
    }
    appointEOARepresentative(eoaRepresentative) {
        return (0, zec_1._appointEOARepresentative)(this.etherSigner, eoaRepresentative);
    }
    appointZECRepresentative(zecRepresentative) {
        return (0, zec_1._appointZECRepresentative)(this.etherSigner, zecRepresentative);
    }
    addDAOToZECCommittee(liquidStakingManagerAddress, daoAddress) {
        return (0, zec_1._addDAOToZECCommittee)(this.etherSigner, liquidStakingManagerAddress, daoAddress);
    }
    removeDAOFromZECCommittee(daoAddress) {
        return (0, zec_1._removeDAOFromZECCommittee)(this.etherSigner, daoAddress);
    }
    whitelistNodeOperators(liquidStakingManagerAddress, nodeOperator) {
        return (0, zec_1._whitelistNodeOperators)(this.etherSigner, liquidStakingManagerAddress, nodeOperator);
    }
    batchWhitelistNodeOperators(liquidStakingManagerAddress, nodeOperators) {
        (0, zec_1._batchWhitelistNodeOperators)(this.etherSigner, liquidStakingManagerAddress, nodeOperators);
    }
    banNodeOperator(nodeOperator) {
        return (0, zec_1._banNodeOperator)(this.etherSigner, nodeOperator);
    }
    depositETH(amount, ethValue) {
        return (0, zec_1._depositETH)(this.etherSigner, amount, ethValue);
    }
    batchRegisterBLSPublicKeysAndETH(blsPublicKeys, blsSignatures, eoaRepresentative, stakeGiantPoolFunds, ethValue) {
        return (0, zec_1._batchRegisterBLSPublicKeysAndETH)(this.etherSigner, blsPublicKeys, blsSignatures, eoaRepresentative, stakeGiantPoolFunds, ethValue);
    }
    sendETHFromGiantPools(liquidStakingManagerAddress, blsPublicKeys, blsSignatures, appointNewEOARepresentative) {
        return (0, zec_1._sendETHFromGiantPools)(this.etherSigner, liquidStakingManagerAddress, blsPublicKeys, blsSignatures, appointNewEOARepresentative);
    }
    callBackETH(liquidStakingManagerAddress, blsPublicKey) {
        return (0, zec_1._callBackETH)(this.etherSigner, liquidStakingManagerAddress, blsPublicKey);
    }
    recoverSigningKeyViaStakehouseProtocol(liquidStakingManagerAddress, blsPublicKey, hAesPublicKey) {
        (0, zec_1._recoverSigningKeyViaStakehouseProtocol)(this.etherSigner, liquidStakingManagerAddress, blsPublicKey, hAesPublicKey);
    }
    recoverSigningKeyViaZEC(blsPublicKey, stakehouseAddress, hAesPublicKey) {
        return (0, zec_1._recoverSigningKeyViaZEC)(this.etherSigner, blsPublicKey, stakehouseAddress, hAesPublicKey);
    }
    rageQuit(blsPublicKey, finalisedEpochReport, reportSignature) {
        return (0, zec_1._rageQuit)(this.etherSigner, blsPublicKey, finalisedEpochReport, reportSignature);
    }
    applyForNodeOperatorClaimingRewards() {
        return (0, zec_1._applyForNodeOperatorClaimingRewards)(this.etherSigner);
    }
    claimRewards(liquidStakingManagerAddresses, blsPublicKeys, recipient) {
        return (0, zec_1._claimRewards)(this.etherSigner, liquidStakingManagerAddresses, blsPublicKeys, recipient);
    }
    fetchZECRewards(liquidStakingManagerAddresses, blsPublicKeys) {
        return (0, zec_1._fetchZECRewards)(this.etherSigner, liquidStakingManagerAddresses, blsPublicKeys);
    }
    totalRewardsReceived() {
        return (0, zec_1._totalRewardsReceived)(this.etherSigner);
    }
    getTotalLiquidityInActiveRangeForUser(userAddress) {
        return (0, zec_1._getTotalLiquidityInActiveRangeForUser)(this.etherSigner, userAddress);
    }
    depositRagequitETH(blsPublicKey, ethValue) {
        return (0, zec_1._depositRagequitETH)(this.etherSigner, blsPublicKey, ethValue);
    }
    claimRagequitETH(blsPublicKey, recipient) {
        return (0, zec_1._claimRagequitETH)(this.etherSigner, blsPublicKey, recipient);
    }
    previewNodeOperatorRewards(nodeOperator) {
        return (0, zec_1._previewNodeOperatorRewards)(this.etherSigner, nodeOperator);
    }
    slash(stakehouseAddress, liquidStakingManagerAddress, blsPublicKey, finalisedEpochReport, reportSignature, ethValue) {
        return (0, zec_1._slash)(this.etherSigner, stakehouseAddress, liquidStakingManagerAddress, blsPublicKey, finalisedEpochReport, reportSignature, ethValue);
    }
    withdrawETH(amount) {
        return (0, zec_1._withdrawETH)(this.etherSigner, amount);
    }
}
exports.ZECSubPackage = ZECSubPackage;
